export const FORM_IDS = {
  CREATE: "create-partner-form",
  EDIT: "edit-partner-form",
  DELETE: "delete-partner-form",
};
